import type { ReactNode } from 'react';
import { Route, type RouteObject } from 'react-router';

export const generateRouteElements = (routes: RouteObject[]): ReactNode =>
	routes.map((route, index) => {
		if (route.index) {
			return (
				<Route
					key={`index-${index}`}
					index
					Component={route.Component ?? undefined}
				/>
			);
		}

		return (
			<Route
				key={route.path ?? `route-${index}`}
				path={route.path}
				Component={route.Component ?? undefined}
			>
				{route.children && generateRouteElements(route.children)}
			</Route>
		);
	});
